<span>
  <label *ngIf="props.altLabel" [for]="field.id">{{ props.altLabel }}</label>
  <input
    pInputText
    [type]="props.type ? props.type : 'text'"
    [min]="props.min ? props.min : 0"
    [max]="props.max"
    autocomplete="off"
    class="{{ !!formControl.value ? 'p-filled' : '' }}"
    [id]="field.id"
    [name]="field.id"
    [placeholder]="props.placeholder"
    [minlength]="props.minlength"
    [maxlength]="props.maxlength"
    [readonly]="props.readonly"
    [required]="props.required"
    [formControl]="formControl"
    [formlyAttributes]="field"
    (keydown)="props.keydown ?? onKeyDown($event)"
  />
</span>
